/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { AgendaCommercialeDashboardDtoFromJSON, AgendaCommercialeDashboardInputDtoToJSON, AgendaCommercialeDtoFromJSON, AgendaCommercialeDtoToJSON, AgendaCommercialeFilterOptionsDtoFromJSON, AgendaCommercialeSearchDtoToJSON, RptAgendaCommercialePagedDtoFromJSON, RptOpportunityPagedDtoFromJSON, RptOpportunitySearchDtoToJSON, } from '../models/index';
/**
 *
 */
export class AgendaCommercialeControllerApi extends runtime.BaseAPI {
    /**
     * Elimina per id il record di agenda_commerciale. L\'eliminazione è consentita solo se il record appartiene a una struttura visibile all\'utente loggato.
     * Elimina un\'azione dell\'Agenda Commerciale
     */
    deleteAgendaCommercialeRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['id'] == null) {
                throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling deleteAgendaCommerciale().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/agenda-commerciale/action/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Elimina per id il record di agenda_commerciale. L\'eliminazione è consentita solo se il record appartiene a una struttura visibile all\'utente loggato.
     * Elimina un\'azione dell\'Agenda Commerciale
     */
    deleteAgendaCommerciale(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteAgendaCommercialeRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Restituisce KPI e aggregazioni per una struttura business e tutte le sue discendenti (visibilità ulteriormente filtrata per i ruoli non admin). Il parametro \'idStrutturaBusiness\' è opzionale: se omesso, gli utenti con ruoli di bypass (SUPER_ADMIN, ADMIN_AGENDA, ALL_READ_ONLY, CONTROLLO_DI_GESTIONE) ottengono la dashboard aggregata su tutte le strutture, mentre gli altri utenti ottengono l\'aggregato sulle sole strutture su cui hanno visibilità (L1/L2/L3). Le metriche \'azioni ultima settimana\' e \'azioni mese corrente\' sono sempre ancorate alle date reali; le altre metriche rispettano l\'eventuale range temporale \'periodoDa\'/\'periodoA\'. Il parametro \'limit\' (default 10) si applica solo all\'elenco \'prossimeAttivitaPerCliente\'.
     * Dati aggregati per la dashboard dell\'Agenda Commerciale
     */
    getAgendaCommercialeDashboardRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['agendaCommercialeDashboardInputDto'] == null) {
                throw new runtime.RequiredError('agendaCommercialeDashboardInputDto', 'Required parameter "agendaCommercialeDashboardInputDto" was null or undefined when calling getAgendaCommercialeDashboard().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/agenda-commerciale/dashboard`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: AgendaCommercialeDashboardInputDtoToJSON(requestParameters['agendaCommercialeDashboardInputDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => AgendaCommercialeDashboardDtoFromJSON(jsonValue));
        });
    }
    /**
     * Restituisce KPI e aggregazioni per una struttura business e tutte le sue discendenti (visibilità ulteriormente filtrata per i ruoli non admin). Il parametro \'idStrutturaBusiness\' è opzionale: se omesso, gli utenti con ruoli di bypass (SUPER_ADMIN, ADMIN_AGENDA, ALL_READ_ONLY, CONTROLLO_DI_GESTIONE) ottengono la dashboard aggregata su tutte le strutture, mentre gli altri utenti ottengono l\'aggregato sulle sole strutture su cui hanno visibilità (L1/L2/L3). Le metriche \'azioni ultima settimana\' e \'azioni mese corrente\' sono sempre ancorate alle date reali; le altre metriche rispettano l\'eventuale range temporale \'periodoDa\'/\'periodoA\'. Il parametro \'limit\' (default 10) si applica solo all\'elenco \'prossimeAttivitaPerCliente\'.
     * Dati aggregati per la dashboard dell\'Agenda Commerciale
     */
    getAgendaCommercialeDashboard(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAgendaCommercialeDashboardRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Restituisce le liste di valori da popolare nelle select del frontend: \'accounts\' (per utenti non admin filtrati sulle strutture commerciali su cui l\'utente è L1/L2/L3 responsabile) e \'statiOpportunity\' (valori ammessi per il filtro Stato_Opportunity).
     * Opzioni per i filtri dell\'Agenda Commerciale
     */
    getAgendaCommercialeFilterOptionsRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/agenda-commerciale/filters`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => AgendaCommercialeFilterOptionsDtoFromJSON(jsonValue));
        });
    }
    /**
     * Restituisce le liste di valori da popolare nelle select del frontend: \'accounts\' (per utenti non admin filtrati sulle strutture commerciali su cui l\'utente è L1/L2/L3 responsabile) e \'statiOpportunity\' (valori ammessi per il filtro Stato_Opportunity).
     * Opzioni per i filtri dell\'Agenda Commerciale
     */
    getAgendaCommercialeFilterOptions(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAgendaCommercialeFilterOptionsRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Se il campo id è null viene creato un nuovo record; se è valorizzato il record esistente viene aggiornato. Restituisce l\'entity persistita con id, creationDate e lastmodifiedDate valorizzati.
     * Crea o aggiorna un\'azione dell\'Agenda Commerciale
     */
    saveOrUpdateAgendaCommercialeRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['agendaCommercialeDto'] == null) {
                throw new runtime.RequiredError('agendaCommercialeDto', 'Required parameter "agendaCommercialeDto" was null or undefined when calling saveOrUpdateAgendaCommerciale().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/agenda-commerciale/action`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: AgendaCommercialeDtoToJSON(requestParameters['agendaCommercialeDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => AgendaCommercialeDtoFromJSON(jsonValue));
        });
    }
    /**
     * Se il campo id è null viene creato un nuovo record; se è valorizzato il record esistente viene aggiornato. Restituisce l\'entity persistita con id, creationDate e lastmodifiedDate valorizzati.
     * Crea o aggiorna un\'azione dell\'Agenda Commerciale
     */
    saveOrUpdateAgendaCommerciale(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.saveOrUpdateAgendaCommercialeRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Ricerca paginata e ordinabile sulla view RPT_agenda_commerciale (denormalizzata con nome progetto, denominazione opportunità e nome account). Filtri: cliente, struttura business, modalità di contatto, esito, range data azione. Per utenti non admin il risultato è limitato alle strutture commerciali su cui l\'utente è L1/L2/L3 responsabile.
     * Ricerca azioni dell\'Agenda Commerciale
     */
    searchAgendaCommercialeRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['agendaCommercialeSearchDto'] == null) {
                throw new runtime.RequiredError('agendaCommercialeSearchDto', 'Required parameter "agendaCommercialeSearchDto" was null or undefined when calling searchAgendaCommerciale().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/agenda-commerciale/action/search`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: AgendaCommercialeSearchDtoToJSON(requestParameters['agendaCommercialeSearchDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => RptAgendaCommercialePagedDtoFromJSON(jsonValue));
        });
    }
    /**
     * Ricerca paginata e ordinabile sulla view RPT_agenda_commerciale (denormalizzata con nome progetto, denominazione opportunità e nome account). Filtri: cliente, struttura business, modalità di contatto, esito, range data azione. Per utenti non admin il risultato è limitato alle strutture commerciali su cui l\'utente è L1/L2/L3 responsabile.
     * Ricerca azioni dell\'Agenda Commerciale
     */
    searchAgendaCommerciale(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.searchAgendaCommercialeRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Ricerca paginata e ordinabile sulla view RPT_Opportunity (filtri: cliente, struttura business, range percentuale di probabilità, range data potenziale avvio).
     * Ricerca opportunità per l\'Agenda Commerciale
     */
    searchOpportunityRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['rptOpportunitySearchDto'] == null) {
                throw new runtime.RequiredError('rptOpportunitySearchDto', 'Required parameter "rptOpportunitySearchDto" was null or undefined when calling searchOpportunity().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("Bearer", ["Bearer"]);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/agenda-commerciale/opportunity/search`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: RptOpportunitySearchDtoToJSON(requestParameters['rptOpportunitySearchDto']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => RptOpportunityPagedDtoFromJSON(jsonValue));
        });
    }
    /**
     * Ricerca paginata e ordinabile sulla view RPT_Opportunity (filtri: cliente, struttura business, range percentuale di probabilità, range data potenziale avvio).
     * Ricerca opportunità per l\'Agenda Commerciale
     */
    searchOpportunity(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.searchOpportunityRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
